import { HemisphereLightHelper, HemisphereLight, Object3D } from "three";

export class IndoorLighting extends Object3D {
  params = {
    debugHemi: false,
    hemiIntensity: 26,
    hemiGroundColor: 0x81108,
    hemiSkyColor: 0x8c98c8,
  };

  private hemi: HemisphereLight;

  private helpers: {
    hemi: HemisphereLightHelper;
  };

  constructor() {
    super();

    this.hemi = new HemisphereLight(
      this.params.hemiSkyColor,
      this.params.hemiGroundColor,
      this.params.hemiIntensity
    );
    this.hemi.position.set(0, 1, 0);

    this.helpers = {
      hemi: new HemisphereLightHelper(this.hemi, 10),
    };

    this.helpers.hemi.visible = false;

    this.add(this.helpers.hemi);

    this.add(this.hemi);
  }

  update() {
    if (this.params.debugHemi) {
      this.hemi.intensity = this.params.hemiIntensity;
      this.hemi.color.setHex(this.params.hemiSkyColor);
      this.hemi.groundColor.setHex(this.params.hemiGroundColor);
    }
  }

  helpersOn(on: boolean) {
    this.helpers.hemi.visible = on;
  }
}
